import { Stack, useTheme } from "@mui/material";
import type { FC, PropsWithChildren, ReactNode } from "react";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

type Props = {
	title: string;
	hero?: ReactNode;
	menu?: ReactNode;
	replaceOnBack?: boolean;
};

export const DetailLayout: FC<PropsWithChildren<Props>> = ({
	title,
	hero,
	menu,
	children,
	replaceOnBack = true,
}) => {
	const theme = useTheme();

	return (
		<MyPlannLayout
			bgColor={theme.palette.grey[50]}
			disableContentPadding
			disableBottomPadding
			topBar={
				<NavigationHeader
					title={title}
					bgColor={theme.palette.background.paper}
					defaultRoute={Routing.Portfolio.PortfolioList.path()}
					backIconColor={theme.palette.grey[900]}
					backIconSize={theme.iconSize.md}
					replaceOnBack={replaceOnBack}
					endComponent={menu}
				/>
			}
		>
			{hero}
			<Stack pb={theme.spacingTokens.xl}>{children}</Stack>
		</MyPlannLayout>
	);
};
